import Spacer from 'components/helper/Spacer';
import ButtonBar from 'components/molecules/ButtonBar';
import i18n from 'helper/i18n';
import { compileDynamicRoute } from 'helper/string';
import * as React from 'react';
import { memo } from 'react';

// FIXME:F2TS type import from flow
import { WithRouterType } from 'types/withRouter';

export type CardDetailOptionaPropsType = {
	id: string;
	title: string;
	text: string;
	externalId?: string;
	programItemRef?: string;
	currentDayNumber: number;
	doSwapItem: (contentType: string, externalId: string) => void;
	doSetProgramItemRef: (programItemRef: string, programItemExternalRef?: string) => void;
	doSetDayRef: (day: number) => void;
} & WithRouterType;

export class CardDetailOptional extends React.Component<CardDetailOptionaPropsType> {
	public static displayName = 'CardDetailOptional';

	public handleButtonClicks = (buttonType: string): void => {
		const { history } = this.props;
		const programItemId = this.props.id;

		switch (buttonType) {
			case 'pool':
				const { doSetDayRef, currentDayNumber, doSetProgramItemRef } = this.props;
				const targetPoolURL = compileDynamicRoute(i18n('react.impulsCoach.routes.pool.cluster.href'), {
					selectedPool: i18n('react.impulsCoach.routes.pool.selectedPool.workout.href'),
					cluster: i18n('react.impulsCoach.routes.pool.cluster.all.href'),
				});

				doSetProgramItemRef(programItemId, this.props.externalId);
				doSetDayRef(currentDayNumber);
				history.push(targetPoolURL);
				break;
			default:
				break;
		}
	};

	public render() {
		const { title, text } = this.props;

		return (
			<div className="m-card__content">
				<div className="m-card__info">
					<h4 className="m-card__info-title">{title}</h4>
					<Spacer size="xl" />
					<Spacer size="l" />
					<div className="m-rich">
						<p>{text}</p>
					</div>
				</div>
				<div className="m-card__button-bar" style={{ paddingTop: 0 }}>
					<ButtonBar
						handleButtonClicks={this.handleButtonClicks}
						buttons={[
							{
								id: 'change-workout',
								modifier: '',
								link: {
									iconRight: '',
									iconLeft: 'change',
									title: i18n('react.impulsCoach.components.cardDetail.workout.optional.poolText'),
									buttonBarId: 'pool',
								},
							},
						]}
					/>
				</div>
			</div>
		);
	}
}

export default memo(CardDetailOptional);
